export const mppAppRoutesToRedirect: Record<
  string,
  {screenName: string; path: string}
> = {
  Home: {
    screenName: 'Home',
    path: '/app/home',
  },
  ScoreSheet: {
    screenName: 'ScoreSheet',
    path: '/app/home/scoresheet/:championshipId/:matchId',
  },
  Messages: {
    screenName: 'Messages',
    path: '/app/home/messages',
  },
  WallMessage: {
    screenName: 'WallMessage',
    path: '/app/home/messages/wall/:referenceId',
  },
  PrivateMessage: {
    screenName: 'PrivateMessage',
    path: '/app/home/messages/private/:contactId',
  },
  Results: {
    screenName: 'Results',
    path: '/app/results',
  },
  Ranking: {
    screenName: 'Ranking',
    path: '/app/ranking/:tab?',
  },
  Leagues: {
    screenName: 'Leagues',
    path: '/app/competitions',
  },
  LeagueDetails: {
    screenName: 'LeagueDetails',
    path: '/app/competitions/:contestId',
  },
  JoinLeague: {
    screenName: 'JoinLeague',
    path: '/app/competitions/:contestId/:joinedMode',
  },
  Profil: {
    screenName: 'Profil',
    path: '/app/profile',
  },
  PublicProfile: {
    screenName: 'PublicProfil',
    path: '/app/profile/:userId',
  },
  Shop: {
    screenName: 'Shop',
    path: '/app/shop/:item?',
  },
};



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Notifications/constant.ts